import React, { FC, useContext } from "react";
import { Location } from "history";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { OrderContext } from "../pages/Preview";

interface Props {
	orderId: number | string;
}

const SubmenuOrderPreviewNavigation: FC<Props> = ({ orderId }) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();
	const { order, orderInvoices } = useContext(OrderContext);

	const getInvoicesLink = () => {
		if (orderInvoices && orderInvoices.length > 0) {
			const invoiceId = orderInvoices[orderInvoices.length - 1].id;
			return `/${organization.id}/documents/sales/${orderId}/invoices/${invoiceId}`;
		}
		return `/${organization.id}/documents/sales/${orderId}/invoices/new`;
	};

	return (
		<div className="content-navigation">
			{
				<Nav>
					<Nav.Item>
						<Nav.Link
							as={NavLink}
							to={`/${organization.id}/documents/sales/${orderId}`}
							isActive={(_, location: Location) =>
								!location.pathname.includes("/transactions") && !location.pathname.includes("/invoices")
							}
						>
							{t("lib:common.action.preview")}
						</Nav.Link>
					</Nav.Item>
					{(order.status === "PARTIALLY_SHIPPED" ||
						order.status === "SHIPPED" ||
						order.status === "OPEN") && (
						<Nav.Item>
							<Nav.Link as={NavLink} to={getInvoicesLink()}>
								{t("modules.order.field.invoices.title")}
							</Nav.Link>
						</Nav.Item>
					)}
					{/* <Nav.Item>
						<Nav.Link as={NavLink} to={`/${organization.id}/documents/sales/${orderId}/transactions`}>
							{t("common.word.transactions")}
						</Nav.Link>
					</Nav.Item> */}
				</Nav>
			}
		</div>
	);
};

export default SubmenuOrderPreviewNavigation;
